import React from 'react'
import PropTypes from 'prop-types'

export default function Title({heading, subHeading, testId}) {
    return <div className="text-center mb-4 title">
        <h1 className="h2 mb-4" data-test-id={testId + '-head'}>{heading}</h1>
        { subHeading && <p data-test-id={testId + '-sub'}>{subHeading}</p>}
    </div>
}

Title.propTypes = {
    heading: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]).isRequired,
    subHeading: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]),
    testId: PropTypes.string.isRequired
}